export default __webpack_public_path__ + "static/media/e-filing-logotype-l.41fb0f4c.svg";